import ApiService from '../../utils/fetch';

const outboundDeliveryUrl = `${process.env.REACT_APP_BASE_URL}demand/deliveries/`;

export const fetchHeaderData = async (deliveryNo, shipFrom) => {
    const response = await ApiService.get(`${outboundDeliveryUrl}${deliveryNo}/${shipFrom}`);
    return response.data;
};
export const fetchDeliveryLinesData = async (deliveryNo) => {
  const response = await ApiService.get(`${outboundDeliveryUrl}${deliveryNo}/lines`);
  return response.data;
};
